var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_station statin-page"
  }, [_c('div', {
    class: ['tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3', 'tw-gap-0 md:tw-gap-6', 'tw-shadow md:tw-shadow-none', 'tw-rounded md:tw-rounded-none', 'tw-overflow-hidden md:tw-overflow-visible']
  }, [_vm.stationLists ? [_vm._l(_vm.stationLists.first, function (item, index) {
    return [item.isUserName ? [_c('div', {
      key: `station-list-first-route-${index}`,
      staticClass: "station-list-item relative md:tw-hidden"
    }, [_c('UserBox', {
      attrs: {
        "user-name": item.key,
        "user-rank-title": _vm.getUserRankTitle(item.badgeData),
        "user-rank-image-url": _vm.getUserRankImageURL(item.badgeData)
      }
    })], 1)] : [item.emit && !item.route ? [_c('a', {
      key: `station-list-first-route-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item),
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onEmit(item.emit);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : item.route && item.isExternalRoute ? [_c('a', {
      key: `station-list-first-isExternalRoute-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item),
      attrs: {
        "target": "_blank",
        "href": item.route
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : [_c('nuxt-link', {
      key: `station-list-first-else-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item),
      attrs: {
        "to": _vm.localePath(item.route)
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), !item.isUserName && !item.isUserLogin ? _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1) : _vm._e(), _vm._v(" "), item.isUserLogin ? _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      attrs: {
        "type": "image",
        "loader": "data",
        "name": `User-Active-${_vm.$store.getters.get_app_theme_mode}`,
        "width": "44",
        "height": "44"
      }
    })], 1) : _vm._e()])]]];
  }), _vm._v(" "), _vm._l(_vm.stationLists.second, function (item, index) {
    return [item.emit && !item.route ? [_c('a', {
      key: `station-list-second-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item, true),
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onEmit(item.emit);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : item.route && item.isExternalRoute ? [_c('a', {
      key: `station-list-second-isExternalRoute-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item, true),
      attrs: {
        "target": "_blank",
        "href": item.route
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : [_c('nuxt-link', {
      key: `station-list-second-else-${index}`,
      staticClass: "md:tw-shadow",
      class: _vm.itemClass(item, true),
      attrs: {
        "to": _vm.localePath(item.route)
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])]];
  })] : _vm._e()], 2), _vm._v(" "), _vm.stationLists.second && _vm.stationLists.second.length > 0 ? _c('div', {
    staticClass: "d-grid grid-cols-1 gap-0 mt-20 box-rounded shadowed overflow-hidden md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-6 md:tw-shadowed-none md:tw-hidden"
  }, [_vm._l(_vm.stationLists.second, function (item, index) {
    return [item.emit && !item.route ? [_c('a', {
      key: `station-list-other-second-${index}`,
      class: _vm.itemClass(item),
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onEmit(item.emit);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : item.route && item.isExternalRoute ? [_c('a', {
      key: `station-list-other-second-isExternalRoute-${index}`,
      class: _vm.itemClass(item),
      attrs: {
        "target": "_blank",
        "href": item.route
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])] : [_c('nuxt-link', {
      key: `station-list-other-second-else-${index}`,
      class: _vm.itemClass(item),
      attrs: {
        "to": _vm.localePath(item.route)
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.itemKey(item)))]), _vm._v(" "), _c('span', {
      class: _vm.iconWrapperClass()
    }, [_c('a-icon', {
      class: {
        'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
      },
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-package-arrow-general-light",
        "width": "22",
        "height": "22"
      }
    })], 1)])]];
  })], 2) : _vm._e(), _vm._v(" "), _vm.logOutItem ? _c('div', {
    staticClass: "d-grid grid-cols-1 gap-0 mt-20 box-rounded shadowed overflow-hidden md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-6 md:tw-shadowed-none md:tw-hidden"
  }, [_c('a', {
    class: _vm.itemClass(_vm.logOutItem),
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onEmit(_vm.logOutItem.emit);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.logOutItem.key)))]), _vm._v(" "), _c('span', {
    class: _vm.iconWrapperClass()
  }, [_c('a-icon', {
    class: {
      'rtl-transform-rotate-y': _vm.$dir() === 'rtl'
    },
    attrs: {
      "type": "image",
      "loader": "data",
      "name": "ic_logout",
      "width": "22",
      "height": "22"
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }